/** @constant {obj} calendar error list */
export const ERRORS = {
  DRAG_NOT_ALLOWED: 'drag_not_allowed',
}

export const ACTION_TYPES = {
  NO_SHOW: 'no_show',
}

export const VIEWS = Object.freeze({
  APPOINTMENT_FORM: 'AppointmentForm',
  CUSTOMER_SELECT: 'CustomerSelect',
  TRAVELING_FORM: 'TravelingForm',
  SERVICE_SELECT: 'ServiceSelect',
  ADDONS_SELECT: 'AddonsSelect',
  MULTIBOOKING_EDIT: 'MultibookingEdit',
  COMBO_VIEW: 'ComboView',
})

export const APPOINTMENT_EVENTS = {
  CHANGE: 'appointment-change',
  REPEATING_DELETED: 'repeating-deleted',
  SAVE_SUCCESS: 'save-success',
  SAVE_ACTION_SUCCESS: 'save-action-success',
}

export const ANY_RESOURCE_ID = -1

export const RESOURCES_AVAILABILITY_TYPES = {
  INFO: 'info',
  ERROR: 'error',
}

export const ANALYTICS_SCREEN_NAMES = {
  NEW_APPOINTMENT: 'new_appointment',
  BA_DEPOSIT_AMOUNT: 'ba_deposit_amount',
  BA_DEPOSIT_PAYMENT: 'ba_deposit_payment',
  BA_DEPOSIT_RESULT: 'ba_deposit_result',
  REDO_BB: 'redo_bb',
}

export const DEPOSIT_PAYMENT_METHODS = Object.freeze({
  CARD: 'card',
  BLIK: 'blik',
})

export const DEPOSIT_TYPE = Object.freeze({
  BLIK_DEPOSIT: 'blik-deposit',
  KEYED_IN_PAYMENT: 'keyed-in-payment',
})
